export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-01.99ba8fae.svg";